/*
 * uuid のラップ関数（ID作成）
 * https://github.com/uuidjs/uuid
 */
import { v4 } from 'uuid';
/**
 * uuid.v4(): ランダムな文字列のID作成
 * @description https://github.com/uuidjs/uuid#uuidv4options-buffer-offset
 * @returns {string} ユニークID
 */
export const createRandomStringId = v4;
